import { notification } from 'antd';

export function copyText(text: string) {
  navigator.clipboard.writeText(text);
  notification.success({
    message: 'copied',
  });
}

export async function writeClipboard(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    // Outside a secure context the async API refuses; the old command still works.
    const area = document.createElement('textarea');
    area.value = value;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.left = '-9999px';
    document.body.appendChild(area);
    area.select();
    const copied = document.execCommand('copy');
    document.body.removeChild(area);
    return copied;
  }
}
